import ErrorBoundary from '@/components/ErrorBoundary';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { widthToClass, withDebugMetadata } from 'lib/utils';
import { standaloneComponent } from 'modules/dynamic-components';
import { Markup, MarkupProps } from './Markup';

export interface StandaloneMarkupProps extends StandaloneComponentProps<typeof Markup> {
  markup?: MarkupProps['markup'];
}

export const StandaloneMarkup: StandaloneComponent<StandaloneMarkupProps> = ({ markup, options, ...props }) => {
  return (
    <ErrorBoundary>
      <Markup {...{ markup }} {...options} {...props} />
    </ErrorBoundary>
  );
};

const DynamicStandaloneMarkup = standaloneComponent('ContentMarkup') as typeof standalone;

const LabradorMarkup: LabradorComponent = ({ type, meta, data, descendants }) => {
  const widthClass = widthToClass(meta.width);

  return (
    <DynamicStandaloneMarkup
      markup={data.markup}
      options={{ className: widthClass }}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export const standalone = StandaloneMarkup;

export default LabradorMarkup;
